<template>
  <body v-if="!isResetTokenLoading">
    <div class="header">
      HR モンスター
    </div>
    <div class="form" v-if="isResetTokenExpired&&!success">
      <b-field>
        <b style="font-size: 20px;">本登録画面</b>
      </b-field>
      <b-field
        label="パスワード"
        class="input-form">
        <b-input type="password"
                 icon="lock"
                 minlength="8"
                 v-model="oldPassword"
                 password-reveal></b-input>
      </b-field>
      <b-field
        label="パスワード(確認)"
        class="input-form">
        <b-input type="password"
                 icon="lock"
                 minlength="8"
                 v-model="newPassword"
                 password-reveal></b-input>
      </b-field>
      <b-field style="margin-top: 50px;">
        <button class="button is-primary"
                style="border-radius: 20px;"
                v-if="disabled" :disabled="disabled">設定する</button>
        <button class="button is-primary"
                style="border-radius: 20px;"
                @click="changePassword()"
                v-if="!disabled" :disabled="disabled">設定する</button>
      </b-field>
    </div>
    <div class="form" v-if="!isResetTokenExpired&&!success">
      <b-field>
        <b style="font-size: 1.0em;">本登録画面</b>
      </b-field>
      <b-field style="margin-top: 5vh;">
        <b-message type="is-danger" style="font-size: 0.85em;" has-icon>
          大変申し訳ございません。パスワードの期限が過ぎているか、既に設定されております。<br>
          <br>
          再発行ボタンで本登録が再開できます。<br>
          再開できない場合は招待していただいた方へ連絡し、再招待を依頼してください。
        </b-message>
      </b-field>
      <button class="button is-primary"
              style="border-radius: 20px;"
              @click="reIssue()">
              再発行
      </button>
    </div>
    <div class="form" v-if="success">
      <p>パスワード設定完了しました。</p>
      <p>以下をクリックし、ログインしてください。</p>
      <button class="button" style="margin-top: 5vh; border-radius: 20px; color: white;">
        <router-link to="/login">ログインページへ</router-link>
      </button>
    </div>
    <div class="footer">
      パスワードを設定してください。このURLは24時間以内のみ有効となります。
      無効となった場合は招待していただいた方へ連絡し、再招待をしてください。
    </div>
  </body>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AddMemberView',
  componentName: 'AddMemberView',
  computed: {
    ...mapState('auth', ['success', 'error', 'isResetTokenExpired', 'finishReIssue', 'isResetTokenLoading', 'isModalPasswordReset']),
    disabled () {
      return this.newPassword === '' || this.oldPassword === '' || this.oldPassword !== this.newPassword || this.oldPassword.length < 8 || this.newPassword.length < 8
    }
  },
  data () {
    return {
      newPassword: '',
      oldPassword: ''
    }
  },
  watch: {
    finishReIssue () {
      this.$router.go({path: this.$router.currentRoute.path, force: true})
    }
  },
  methods: {
    changePassword () {
      console.debug('*** Start *** changePassword') 
      this.$store.dispatch('auth/reCreatePassword', {password: this.newPassword, id: this.$route.params.uuid})
      console.debug('*** End *** changePassword') 
    },
    reIssue () {
      console.debug('*** Start *** reIssue')
      console.debug('url_uuid: ' + this.$route.params.uuid) 
      this.$store.dispatch('auth/reIssue', this.$route.params.uuid)
      console.debug('*** End *** reIssue')
    }
  },
  created () {
    console.debug('*** Start *** created') 
    this.$store.dispatch('auth/checkToken', this.$route.params.uuid)
    console.debug('*** End *** created') 
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.header {
  background-color: #313E4D;
  text-align: left;
  height: 15vh;
  padding: 5vh;
  color: white;
  font-size: 30px;
}
.form {
  display: inline-block;
  text-align: center;
  overflow-y: scroll;
  margin-top: 30px;
  height: 60vh;
  width: 80vw;
  min-height: 300px;
  max-width: 500px;
  padding: 30px;
  background-color: #FEFEFE;
  border-radius: 10px;
}
.input-form {
  text-align: left;
  margin-top: 40px;
}
.footer {
  position: absolute;
  bottom: 0;
  background-color: #313E4D;
  height: 10vh;
  width: 100vw;
  padding: 2vh;
  overflow-y: scroll;
  color: white;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/AddMember/AddMemberView.vue